import { render, staticRenderFns } from "./SmplAdd.vue?vue&type=template&id=23e80ca2&scoped=true&"
import script from "./SmplAdd.vue?vue&type=script&lang=js&"
export * from "./SmplAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e80ca2",
  null
  
)

export default component.exports